module.exports = __webpack_public_path__ + "img/driversLicenseExampleBackOutlined.e565c51f.svg";